import ForgotPasswordModalContainer from './ForgotPasswordModalContainer';

export default ForgotPasswordModalContainer;
